import React, { useEffect, useState } from "react";
import { Button, Spinner, Modal, Form as BsForm } from "react-bootstrap";
import { ErrorMessage, Field, Formik, Form as FormikForm } from "formik";

import { createResources, createTermsConditions, deleteTermsConditions, getResources, getTermsConditions, updateTermsConditions } from "../../services/Admin/adminServices";
 
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import * as Yup from "yup";
 
const Terms = () => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
 const [selectedInfo, setSelectedInfo] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [saving,setSaving]=useState(false)
  const fetchData = async () => {
    try {
      const response = await getTermsConditions();

      setInfo(response?.data?.data?.termsAndConditions);
    } catch (error) {
      console.error("Error fetching documentation info:", error);
    } finally {
      setLoading(false);
    }
  };
 useEffect(() => {
    fetchData();
  }, []);

  const handleUpdate = async (values) => {
    try {
      setSaving(true)
      await updateTermsConditions(values); // call update API
      toast.success("updated")
     fetchData();
      setShowModal(false);
    } catch (err) {
      console.error("Update failed:", err);
      toast.error(err?.response?.data?.message)
    }finally{
      setSaving(false)
    }
  };

   const handleEditClick = (info) => {
    setSelectedInfo(info);
    setShowModal(true);
  };
   const handleAdd = () => {
    setShowAdd(true);
    
  };
    const handleDelte = async (id) => {
      try {
        await deleteTermsConditions(id);
        fetchData();
        toast.success("Deleted SuccessFully");
      } catch (error) {
        console.error("Delete error:", error);
      }
    };
  
 
  return (
    <div className=" ">
      <div className="d-flex justify-content-between mb-3">
        <h2 className="mb-3" style={{color:"#64CAE5"}}>Terms & Conditions  </h2>
        <div>
          
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : !info ? (
        <p>No Terms and condition   available.</p>
      ) : (
        <ul>
          <ul className="list-group">
             
              <li
              
                className="list-group-item d-flex justify-content-between flex-column"
                style={{ borderColor: "#64CAE5" }}
              >
            

                  
              <div className="d-flex justify-content-between w-100 " > 
                  <h2 className="fw-bold  mb-1"   >   </h2>
                 <div className="d-flex gap-2" >   

                   <button
                  className="btn  responsive-btn"
                  style={{
                    backgroundColor: "#64CAE5",
                    color: "white",
                    border: "none",
                  }}
                      onClick={() => handleEditClick(info)}
                >
                  Edit
                </button>
                
                </div></div>
                   <div    className="desc-text" dangerouslySetInnerHTML={{ __html: info }} />
              
              </li>
         
          </ul>
        </ul>
      )}

      {/* Edit Modal */}
    {selectedInfo&&(  <Modal size="xl" show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="titleColor">Edit Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            termsAndConditions: selectedInfo || "",
            
          }}
          enableReinitialize
          onSubmit={handleUpdate}
        >
          {({ handleChange, handleSubmit, values,setFieldValue }) => (
            <BsForm onSubmit={handleSubmit}>
              <Modal.Body>
                
                  <div className="mb-3">
                              <label className="form-label">Description</label>
                              
                                <ReactQuill
                                value={values.termsAndConditions}
                      theme="snow"
                      name="description"
                      onChange={(content) => setFieldValue("termsAndConditions", content)}
                       style={{
    borderColor: "#64CAE5",
    height: "100",     // small fixed height
       // enable scroll inside
  }}
                    />
                    <ErrorMessage name="termsAndConditions" component="div" className="text-danger" />
                            </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button disabled={saving} type="submit" style={{ backgroundColor: "#64CAE5", border: "none" }}>
                  {saving ? "saving":"Save Changes"}
                </Button>
              </Modal.Footer>
            </BsForm>
          )}
        </Formik>
      </Modal>)}









      
    </div>
  );
};

export default Terms;
